import { relations } from 'drizzle-orm';
import { index, integer, pgEnum, pgTable, serial, text, timestamp, uniqueIndex } from 'drizzle-orm/pg-core';
import { typeIdDataType as typeId } from '../utils/typeid';
import { account } from './account';
import { apiKey } from './api-key';
import { application } from './application';

export const ACCOUNT_SCOPE_STATUS = ['active', 'disabled'] as const;
export type ScopeStatus = (typeof ACCOUNT_SCOPE_STATUS)[number];
export const accountScopeStatusEnum = pgEnum('account_scope_status', ACCOUNT_SCOPE_STATUS);

export const accountScope = pgTable(
  'account_scope',
  {
    id: serial().primaryKey(),
    public_id: typeId('accountScope', 'public_id').notNull(),
    application_id: integer()
      .references(() => application.id, { onDelete: 'cascade' })
      .notNull(),
    name: text().notNull(),
    reference: text(),
    status: accountScopeStatusEnum().notNull().default('active'),
    created_at: timestamp({ withTimezone: true, mode: 'string' }).notNull().defaultNow(),
  },
  (t) => [
    uniqueIndex('account_scope_public_id_uq').on(t.public_id),
    uniqueIndex('account_scope_application_reference_uq').on(t.application_id, t.reference),
    index('account_scope_application_id_idx').on(t.application_id),
    index('account_scope_application_status_idx').on(t.application_id, t.status),
  ],
);

export const accountScopeRelations = relations(accountScope, ({ one, many }) => ({
  application: one(application, { fields: [accountScope.application_id], references: [application.id] }),
  accounts: many(account),
  apiKeys: many(apiKey),
}));
